"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebsiteAppInitContextProvider = exports.WebsiteAppInitContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var WebsiteAppInitContext = /*#__PURE__*/_react["default"].createContext([{}, function () {}]);

exports.WebsiteAppInitContext = WebsiteAppInitContext;

var WebsiteAppInitContextProvider = function WebsiteAppInitContextProvider(props) {
  var _useState = (0, _react.useState)({
    appConfigParameters: {
      appMaxWidth: null,
      mobileWidth: null,
      GeoLocation: null,
      withCookies: null,
      animationIntro: null,
      animationTime: null
    },
    clientWindowDimensions: {
      isMobile: false,
      windowWidth: null,
      windowHeight: null
    },
    clientDeviceInfo: {
      osName: null,
      osVersion: null,
      browserName: null,
      browserVersion: null,
      fullBrowserVersion: null
    },
    geoLocation: {
      browserLanguage: null,
      country: null,
      countryLanguages: null
    },
    privacyCookies: {
      shown: false,
      accepted: false
    },
    siteCookiesList: null
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(WebsiteAppInitContext.Provider, {
    value: [state, setState]
  }, props.children);
};

exports.WebsiteAppInitContextProvider = WebsiteAppInitContextProvider;